<template>
  <b-modal
    id="modalUniversal"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    :cancel-title="$t('general.close')"
    centered
    size="lg"
    no-close-on-backdrop
    :title="type ? $t('add_materials') : $t('reference.add_ins')"
    @ok="onSave"
    @close="cleanInputs"
    @cancel="cleanInputs"
  >
    <validation-observer ref="contractValidations">
      <b-row>
        <template v-if="type">

          <b-col md="6">
            <b-form-group :label="$t('reference.categoriya')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.categoriya')"
                rules="required"
              >
                <v-select
                  v-model="allData.category"  
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="GET_PRODUCT_CATEGORIES"
                  @input="loadMaterialsByCategory"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>


          <b-col class="col-md-6">
            <b-form-group :label="$t('table.product_type')">
              <validation-provider
                #default="{ errors }"
                :name="$t('table.product_type')"
                rules="required"
              >
                <v-select
                  v-model="allData.good"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="paginatedMaterial"
                  @input="loadMaterials"
                  :filterable="false"
                  @search="onSearch1"
                >
                  <li slot="list-footer" class="pagination">
                    <button :disabled="!hasPrevPage1" @click="offset -= limit" class="w-100">
                      {{$t('prev')}}
                    </button>
                    <button :disabled="!hasNextPage1" @click="offset += limit" class="w-100">
                      {{$t('next')}}
                    </button>
                  </li>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <v-select
                  v-model="allData.good_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="value"
                  :options="getMaterial"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group :label="$t('amount')">
              <validation-provider
                #default="{ errors }"
                :name="$t('amount')"
                rules="required"
              >
                <b-form-input
                  v-model="allData.count"
                  @input="formatPrice(allData.count, 'count')" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                  type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group :label="$t('price')">
              <validation-provider
                #default="{ errors }"
                :name="$t('price')"
                rules="required"
              >
                <b-form-input
                  v-model="allData.price"
                  @input="formatPrice(allData.price, 'price')" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                  type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </template>



        <template v-else>
          <b-col class="col-md-6">
            <b-form-group :label="$t('reference.categoriya')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.categoriya')"
                rules="required"
              >
                <v-select
                  v-model="allData.good"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="GET_INSTRUMENT_CATEGORIES.results"
                  @input="loadInstrument"
                />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group :label="$t('table.product_type')">
              <validation-provider
                #default="{ errors }"
                :name="$t('table.product_type')"
                rules="required"
              >
                <v-select
                  v-model="allData.good_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="getMaterial"
                  @input="loadInstrumentChild"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group :label="$t('model')">
              <validation-provider
                #default="{ errors }"
                :name="$t('model')"
                rules="required"
              >
                <v-select
                  v-model="allData.instrument_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="getInstrumentChild"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group :label="$t('amount')">
              <validation-provider
                #default="{ errors }"
                :name="$t('amount')"
                rules="required"
              >
                <b-form-input
                  v-model="allData.count"
                  @input="formatPrice(allData.count, 'count')" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                  type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col class="col-md-6">
            <b-form-group :label="$t('price')">
              <validation-provider
                #default="{ errors }"
                :name="$t('price')"
                rules="required"
              >
                <b-form-input
                  v-model="allData.price"
                  @input="formatPrice(allData.price, 'price')" 
                  onkeypress="return /[0-9,/.]/i.test(event.key)"
                  type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </template>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@core/utils/validations/validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BModal,
    BFormInput,
    BFormGroup,
    vSelect,
    BRow,
    ValidationObserver,
    ValidationProvider,
    BCol,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    type: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      allData: {
        category: null,
        good: null,
        price: null,
        count: null,
        good_id: null,
        instrument_id: null,
      },
      getMaterial: [],
      getInstrumentChild: [],

      search: '',
      search1: '',
      offset: 0,
      limit: 10,

      offset1: 0,
      limit1: 10,
    }
  },
  computed: {
    ...mapGetters('materials', ['GET_MATERIALS_TABLE_ID', 'GET_MATERIALS', 'GET_PRODUCT_CATEGORIES']),
    ...mapGetters('instruments', [
      'GET_INSTRUMENT_CATEGORIES',
      'GET_INSTRUMENTS_MODEL',
      'GET_INSTRUMENTS_MODEL_VARIANT',
    ]),





    // ========================= SETTERS_AND_GETTERS START =========================
    materialItems: {
      get: function () {
        return this.$store.state.agrements.materialItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_MATERIAL_ITEMS', newValue)
      }
    },
    instrumentItems: {
      get: function () {
        return this.$store.state.agrements.instrumentItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INSTRUMENT_ITEMS', newValue)
      }
    },
    // ========================= SETTERS_AND_GETTERS END =========================


    




    // filtered() {
    //   return this.countries.filter((country) =>
    //     country.toLocaleLowerCase().includes(this.search.toLocaleLowerCase())
    //   )
    // },
    // paginated() {
    //   return this.filtered.slice(this.offset, this.limit + this.offset)
    // },
    // hasNextPage() {
    //   const nextOffset = this.offset + this.limit
    //   return Boolean(
    //     this.filtered.slice(nextOffset, this.limit + nextOffset).length
    //   )
    // },
    // hasPrevPage() {
    //   const prevOffset = this.offset - this.limit
    //   return Boolean(
    //     this.filtered.slice(prevOffset, this.limit + prevOffset).length
    //   )
    // },



    // ===============  PAGINATION_SECTION START ===============
    paginated() {
      return this.filtered.slice(this.offset, this.limit + this.offset);
    },
    paginatedMaterial() {
      return this.GET_MATERIALS.results
    },
    hasNextPage() {
      const nextOffset = this.offset + this.limit;
      return Boolean(
        this.filtered.slice(nextOffset, this.limit + nextOffset).length
      );
    },
    hasPrevPage() {
      const prevOffset = this.offset - this.limit;
      return Boolean(
        this.filtered.slice(prevOffset, this.limit + prevOffset).length
      );
    },
    hasNextPage1() {
      const nextOffset = this.offset1 + this.limit1;
      return Boolean(
        this.GET_MATERIALS.results.slice(nextOffset, this.limit1 + nextOffset)
          .length
      );
    },
    hasPrevPage1() {
      const prevOffset = this.offset1 - this.limit1;
      return Boolean(
        this.GET_MATERIALS.results.slice(prevOffset, this.limit1 + prevOffset)
          .length
      );
    },
    // ===============  PAGINATION_SECTION END ===============






  },
  async mounted() {
    await this.FETCH_INSTRUMENTS_CATEGORY()
    await this.FETCH_PRODUCT_CATEGORIES({mini: true})
    this.GET_PRODUCT_CATEGORIES.unshift({
      id: 0, 
      title: this.$i18n.locale == 'ru' ? "Все" : 'Barchasi',
    })
  },
  methods: {
    ...mapActions('materials', ['FETCH_MATERIALS_TABLE_ID', 'FETCH_MATERIALS', 'FETCH_PRODUCT_CATEGORIES']),
    ...mapActions('instruments', [
      'FETCH_INSTRUMENTS_CATEGORY',
      'FETCH_INSTRUMENTS_MODEL',
      'FETCH_INSTRUMENTS_MODEL_VARIANT',
    ]),




    // ===============  CLEAN_INPUTS_SECTION START ===============
    cleanInputs() {
      this.allData = {
        category: null,
        good: null,
        price: null,
        count: null,
        good_id: null,
        instrument_id: null,
      }
    },
    // ===============  CLEAN_INPUTS_SECTION END ===============







    // ===============  FORMAT_PRICE_SECTION START ===============
    formatPrice(value, type) {
      if(value){
        let currency = value.toString().replace(/,/g, '');
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(currency);

        if(type == 'count'){
          this.allData.count = currency
        }else if(type == 'price'){
          this.allData.price = currency
        }

      }
      return 0;
    },
    // ===============  FORMAT_PRICE_SECTION END ===============





    // ===============  SEARCH_SECTION START ===============
    onSearch(query) {
      this.search = query;
      this.offset = 0;
    },
    onSearch1(query) {
      this.search1 = query;
      this.offset1 = 0;
    },
    // ===============  SEARCH_SECTION END ===============





    // ========================= ON_SAVE START =========================
    async onSave(bvModalEvent) {
      bvModalEvent.preventDefault()
      const success = await this.$refs.contractValidations.validate()
      if (!success) return


      if(this.type){
        this.materialItems.push({product: this.allData.good_id.product.title, good: this.allData.good_id, 
        count: parseFloat(this.allData.count.toString().replace(/,/g, '')), price: parseFloat(this.allData.price.toString().replace(/,/g, ''))})
      }else{
        this.instrumentItems.push({product: this.allData.instrument_id.type.title, good: this.allData.instrument_id, 
        count: parseFloat(this.allData.count.toString().replace(/,/g, '')), price: parseFloat(this.allData.price.toString().replace(/,/g, ''))})
      }

      this.$bvModal.hide('modalUniversal')
      this.$nextTick(() => {
        this.cleanInputs()
      })
    },
    // ========================= ON_SAVE END =========================







    // ========================= LOAD_MATERIALS_AND_INSTRUMENTS_TO_INPUTS START =========================
    async loadMaterialsByCategory(data) {
      if (data.id == 0) {
        await this.FETCH_MATERIALS();
      } else {
        await this.FETCH_MATERIALS({ category: data.id });
      }
    },
    async loadMaterials(data) {
      if (!data) {
        this.getMaterial = []
        this.allData.good_id = null
      } else {
        await this.FETCH_MATERIALS_TABLE_ID({ product: data.id })
        .then(() => {
          this.getMaterial = this.GET_MATERIALS_TABLE_ID.results
        })
      }
    },
    async loadInstrument(data) {
      this.allData.good_id = null
      this.allData.instrument_id = null
      this.getMaterial = []
      await this.FETCH_INSTRUMENTS_MODEL({ category: data.id }).then(() => {
        this.getMaterial = this.GET_INSTRUMENTS_MODEL.results
      })
    },
    async loadInstrumentChild(data) {
      this.allData.instrument_id = null
      this.getInstrumentChild = []
      await this.FETCH_INSTRUMENTS_MODEL_VARIANT({ type: data.id }).then(() => {
        this.getInstrumentChild = this.GET_INSTRUMENTS_MODEL_VARIANT.results
      })
    },
    // ========================= LOAD_MATERIALS_AND_INSTRUMENTS_TO_INPUTS END =========================


    
    
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
